import React from "react";
import ComponenetHeader from "../common/ComponenetHeader";

const RefundAndCancellation = () => {

  return (<>
    {/*  <ComponenetHeader
           name={'Refund And Cancellation'}
        /> */}

    <section className="content_page text-left">
      <div className="container">
        <div className="row content_page_style justify-content-center">
          <div className="col-md-12">
            <h2 className="mb-4">Refund and Cancellation Policy</h2>
            <h3>Cancellation Policy</h3>
            <ul>
              <li>Subscribers may cancel their service within 15 days of signing up or entering into the service agreement.</li>
              <li>Services purchased under promotional or discounted offers cannot be canceled, as these offers are one-time and strictly non-refundable.</li>
              <li>All fees paid are final and non-refundable, even if the cancellation request is submitted within 12 hours of purchase.</li>
              <li>If a scheduled payment is not received within seven (7) business days of the due date, the associated service will be automatically terminated.</li>
            </ul>
            <h3>Refund Policy</h3>
            <ul>
              <li>Refund requests must be submitted within 15 days of the original purchase date.</li>
              <li>Refunds cannot be issued for work already completed, as resources are allocated to each task and progress milestone.</li>
              <li>Administrative charges, setup or installation fees, and taxes imposed by governmental or regulatory bodies are non-refundable under all circumstances.</li>
              <li>Refunds will not be granted if a service is canceled due to a breach of Mechanic Hunt’s Terms and Conditions.</li>
              <li>Mechanic Hunt is not liable to issue refunds for delays, disruptions, or issues caused by third-party service providers or external factors.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </>
  );
};

export default RefundAndCancellation;